// Copyright (c) 2025 Audere, All Rights Reserved

import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import { theme } from "../../theme";
import { createStyleSheet } from "../utils/styles";
import type { TabSwitcherProps } from "../types/projects";

const TabSwitcher = (props: TabSwitcherProps) => {
  const { activeTab, setActiveTab } = props;
  const { t } = useTranslation("TabSwitcher");
  const tabs = [t("validationSetTab"), t("fieldEvaluationTab")];

  return (
    <Box sx={styles.tabContainer}>
      {tabs.map((label, index) => {
        const isActive = activeTab === index;

        return (
          <Button
            key={label}
            variant="contained"
            onClick={() => setActiveTab(index)}
            sx={{
              ...styles.tabButton,
              backgroundColor: isActive ? theme.palette.primary.main : theme.palette.common.white,
              color: isActive ? theme.palette.common.white : theme.palette.common.black,
              borderLeft: index !== 0 ? `1px solid ${theme.palette.grey[300]}` : "none",
              "&:hover": {
                backgroundColor: isActive ? theme.palette.primary.dark : theme.palette.grey[100],
              },
            }}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
};

const styles = createStyleSheet({
  tabContainer: {
    display: "flex",
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: "4px",
    width: "fit-content",
  },
  tabButton: {
    borderRadius: 0,
    boxShadow: "none",
    textTransform: "none",
    fontSize: "17px",
    fontWeight: 400,
  },
});

export default TabSwitcher;
